export default "__VITE_ASSET__DSX75IU4__"